<template>
  <section v-if="leadMessages" class="inspect-lead">
    <div class="block">
      <div class="header">
        <div class="user-infos">
          <h1>{{ leadMessages[0].data.name }}</h1>
          <p>Email: {{ leadMessages[0].data.email }}</p>
          <p>Telefone: {{ leadMessages[0].data.phone }}</p>
          <p>Problemas: {{ problemsCount }}</p>
          <p>Sugestões: {{ sugestionsCount }}</p>
        </div>

        <v-icon name="times" style="cursor: pointer" @click="close()"></v-icon>
      </div>

      <h2>Mensagens</h2>
      <div class="messages">
        <div class="message" v-for="(message, index) in leadMessages" :key="index">
          <h4>
            <label :class="{'pink': message.data.type === 'problem', 'green': message.data.type === 'solution'}">{{ message.data.type === 'problem' ? 'Problema' : 'Sugestão' }} </label>
            | {{ message.data.title }} -
            <span>{{ message.data.ddmmyyyy }}</span>
          </h4>
          <p class="subtitle">{{ message.data.theme }} - {{ message.data.neighborhood.name }} - {{ message.data.neighborhood.region }}</p>
          <p class="message-text">{{ message.data.message }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
  .inspect-lead {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);

    .user-infos {
      margin-bottom: 10px;

      h1 {
        margin: 0;
        padding: 0;
      }

      p {
        margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
      }
    }

    .block {
      width: 50%;
      display: block;
      margin: auto;
      background: #fff;
      border-radius: 10px;
      height: 60%;
      margin-top: 10%;
      padding: 30px;

      .header {
        display: flex;
        justify-content: space-between;

        h1 {
          margin: 0;
          padding: 0;
        }
      }

      h2 {
        margin: 0;
        margin-bottom: 10px;
      }

      .messages {
        overflow-y: scroll;
        max-height: 72%;


        .message {
          border-bottom: 1px solid #ccc;
          padding: 10px;
          overflow-y: scroll;

          h4 {
            margin: 0;
            padding: 0;
            font-weight: 500;

            span {
              font-size: 12px;
              font-weight: 400;
            }

            label {
              &.green {
                color: rgb(0, 155, 58);
              }

              &.pink {
                color: rgb(251, 57, 122);
              }
            }
          }

          p {
            margin: 0;

            &.subtitle {
              font-size: 12px;
              margin-top: 5px;
              margin-bottom: 15px;
            }

            &.message-text {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
</style>
<script>
export default {
  data() {
    return {
      leadMessages: null,
      sugestionsCount: 0,
      problemsCount: 0,
    };
  },

  created() {
    this.bus.$on('inspectLead', (leadMessages) => {
      this.leadMessages = leadMessages;
      this.problemsCount = 0;
      this.sugestionsCount = 0;

      leadMessages.forEach((message) => {
        if (message.data.type === 'problem') {
          this.problemsCount++;
        } else if (message.data.type === 'solution') {
          this.sugestionsCount++;
        }
      });
    });
  },

  methods: {
    close() {
      this.leadMessages = null;
    },
  },
};
</script>
